import React, { useState } from "react";
import { replace } from "lodash";
import { useDispatch } from "react-redux";

import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";
import { useRoutingNumberModal } from "../../reducers/contactsReducer/selectors";
import {
  setShowRemoveRoutingWarning,
  INIT_ROUTING_NUMBER_MODAL,
} from "../../reducers/contactsReducer/contactsReducer";

// If we need to make this more reusable, we can extend by expecting params: show, onClose, phoneNumber, onSubmit
const RemoveRoutingNumberModal = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const { phoneNumber, onSubmit } = useRoutingNumberModal();

  const onCloseHandlr = () => {
    dispatch(setShowRemoveRoutingWarning(INIT_ROUTING_NUMBER_MODAL));
  };

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      contentClassName="tw-w-[440px] tw-flex tw-flex-col tw-gap-[32px]"
      onHide={onCloseHandlr}
      show={Boolean(phoneNumber)}
    >
      <Modal.Header title="Delete Routing Number?" />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[20px]">
        <div>
          <b>
            {phoneNumber
              ? ((n) => `(${n.slice(1, 4)}) ${n.slice(4, 7)}-${n.slice(7, 11)}`)(
                  replace(phoneNumber, /\D/g, ""),
                )
              : "No number"}
          </b>{" "}
          is currently set up as your routing number. Communications routed through your Brivity Number will
          not work properly until you set a new routing number. You can do this from the Phone Settings and
          Personal Settings pages.
        </div>
        <div>Are you sure you want to proceed?</div>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between">
        <Button size="medium" schema="tertiary" onClick={onCloseHandlr}>
          Close
        </Button>
        <Button
          size="medium"
          onClick={async () => {
            setLoading(true);
            await onSubmit();
            setLoading(false);
            onCloseHandlr();
          }}
          schema="warning"
          isLoading={loading}
        >
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveRoutingNumberModal;
